import classNames from 'classnames';
import { attempt } from 'yoso';
import { Collapse, CollapseProps } from '~/components/Collapse/Collapse';
import { useDropdown } from '~/components/Dropdown/Dropdown.hooks';
import styles from './DropdownMenu.module.scss';

export type DropdownMenuProps = Omit<CollapseProps, 'active'>;

export const DropdownMenu = ({ className, children, ...props }: DropdownMenuProps) => {
  const context = useDropdown();

  return (
    <Collapse
      className={classNames(styles.root, styles[context.placement], className)}
      active={context.active}
      {...props}>
      {attempt(children, context)}
    </Collapse>
  );
};
